import { render, staticRenderFns } from "./plugin-sendback.vue?vue&type=template&id=7161b018&scoped=true&"
import script from "./plugin-sendback.vue?vue&type=script&lang=js&"
export * from "./plugin-sendback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7161b018",
  null
  
)

export default component.exports